export const PoemNewTextDocument = () => {
    return (
        <div id="031" className="">
            <p>the default is an vacant lot.</p>
            <p>the default is dying alone,</p>
            <p>strangers on the street,</p>
            <p>one-bedroom apartments,</p>
            <p>perpetual tunnel vision,</p>
            <p>a field of view you can your fit in your palm.</p>
            <p>try hard enough and there's an excuse for everything,</p>
            <p>hand the reins to the proverbial universe,</p>
            <p>i've read somewhere</p>
            <p>that if you don't chew enough as a child</p>
            <p>
                your mouth won't widen itself enough to fit all of your teeth,
            </p>
            <p>technically, you can be smothered in anything,</p>
            <p>i've always wondered</p>
            <p>when is it safe enough to say that you can't do it,</p>
            <p>
                where's the line that delimits self-preservation from
                self-sabotage,
            </p>
            <p>the wish to be in control is quite literally shaped</p>
            <p>like a blade with no handle,</p>
            <p>the knot in my throat and the one in my head,</p>
            <p>all moments are a gamble,</p>
            <p>are a test, are a hope,</p>
            <p>are a stroke of a brush,</p>
            <p>
                thousands of times easier to step away from the canvas than to{" "}
            </p>
            <p>walk in front of it again,</p>
            <p>the default is a blank piece of paper,</p>
            <p>or maybe starvation, or maybe</p>
            <p>being slowly squeezed to death by the things around you,</p>
            <p>every muscle twitch,</p>
            <p>every phrase that wills itself to be</p>
            <p>spit out of your mouth instead of uttered, every</p>
            <p>
                milimeter of your brittle tooth going into the hand that feeds
            </p>
            <p>deviates from the norm.</p>
        </div>
    );
};
